import React from "react";

const ArbeidsgiverOgStillingstittel = ({arbeidsgiver, stillingsprosent, stillingstittel}) =>
    <div className='arbeidsgiver-og-stillingstittel'>
        {arbeidsgiver}{stillingsprosent !== 100 && ` - ${stillingsprosent}%`}{stillingstittel && `, ${stillingstittel}`}
    </div>
;


export default ArbeidsgiverOgStillingstittel;